import { render, staticRenderFns } from "./ColorDot.vue?vue&type=template&id=44657856&scoped=true"
import script from "./ColorDot.vue?vue&type=script&lang=js"
export * from "./ColorDot.vue?vue&type=script&lang=js"
import style0 from "./ColorDot.vue?vue&type=style&index=0&id=44657856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44657856",
  null
  
)

export default component.exports